import axios from 'axios'

export default {
  state: {
    config: window?.config ?? {},
    sidebarMainHeight: 600,
    isDisableInfiniteScrollTrigger: false
  },
  getters: {
    isShowedSkeletons (state) {
      return state?.config?.isShowedSkeletons ?? false
    }
  },
  mutations: {
    SIDEBAR_HEIGHT: (state, data) => {
      if (data) {
        state.sidebarMainHeight = data
      }
    },
    SET_INFINITE_SCROLL_TRIGGER: (state, data) => {
      state.isDisableInfiniteScrollTrigger = data
    }
  },
  actions: {
    SET_INFINITE_SCROLL_TRIGGER_STATUS: ({ commit }, data) => {
      commit('SET_INFINITE_SCROLL_TRIGGER', data)
    },
    FETCH_INITIAL_INFO: ({ commit, rootGetters, rootState, dispatch }) => {
      return new Promise((resolve, reject) => {
        axios
          .get(rootGetters.urlLanguagePrefix + '/get-full-info/')
          .then(response => {
            if (!response.data) {
              commit('SET_ERROR_FROM_SERVER', rootGetters.translations('error_occurred'))
            }

            if (response.data.cart_info) {
              commit('SET_PROMOCODE', response.data.cart_info.promo_data)
              commit('SET_CART', response.data.cart_info)
              commit('SET_CART_SORT', response.data.cart_info.products.map(item => item.id))
              if (window.location.href.includes('checkout')) {
                dispatch('deliveryNew/FETCH_DELIVERY_TYPES', {}, { root: true })
              }
            }

            if (response.data.comparison_info) {
              commit('SET_COMPARISON_INFO_HEADER', response.data.comparison_info)

              let sendFetch = true

              if (window.location.pathname.includes('comparison')) {
                const categories = response.data.comparison_info.data
                for (const categoryId in categories) {
                  for (const productId in categories[categoryId].product_list) {
                    const urlParams = new URLSearchParams(window.location.search)
                    const params = urlParams.get('ids')

                    if (!params) {
                      dispatch('SET_SELECTED_CATEGORY_ACTION', categoryId)
                      sendFetch = false
                      break
                    } else if (params && params.split(',')[0] === productId) {
                      dispatch('SET_SELECTED_CATEGORY_ACTION', categoryId)
                      sendFetch = false
                    }
                  }
                }
              }
              if (sendFetch && window.location.pathname.includes('comparison')) {
                dispatch('FETCH_COMPARISON_INFO')
              }
            }

            if (response.data.wishlist_info) {
              commit('wishlist/SET_SHORT_WISHLIST_INFO', response.data.wishlist_info.wishlist, { root: true })
            }

            if (response.data.waitlist_info) {
              commit('waitlist/SET_SHORT_WAITLIST_INFO', response.data.waitlist_info.waitlist, { root: true })
            }
            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
    SET_SIDEBAR_HEIGHT: ({ commit }, data) => {
      commit('SIDEBAR_HEIGHT', data)
    }
  }
}
